var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"49d9b77128b1944986310a2fea5ca96cfccba40d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sso-spa@didomi"]={id:"49d9b77128b1944986310a2fea5ca96cfccba40d"};
      